import "../css/LoginGlass.css";
import LogoColor from "../media/images/icons/pm_logo.png";
import React, { useEffect, useState } from "react";
import { Formik, Field, Form } from "formik";
import * as Yup from "yup";
import Session from "react-session-api";
import UseFetchData from "../hooks/UseFetchData";
let isFirst = true;
const LoginGlass = () => {
  const [response, fetchData] = UseFetchData();
  const [errortext, setErrortext] = useState("");

  useEffect(() => {
    var form = document.getElementById("loginform");
    form.addEventListener("mousemove", (e) => {
      var x = (window.innerWidth / 2 - e.pageX) / 12;
      var y = (window.innerHeight / 2 - e.pageY) / 12;
      form.style.transform = "rotateX(" + x + "deg) rotateY(" + y + "deg)";
    });

    form.addEventListener("mouseleave", function () {
      form.style.transform = "rotateX(0deg) rotateY(0deg)";
    });
  }, []);

  useEffect(() => {
    setErrortext("");
    if (response.length > 0) {
      // debugger;
      Session.set("UID", response[0].UserID);
      Session.set("UserName", response[0].UserName);
      Session.set("UserType", response[0].UserType);
      Session.set("UserGroupID", response[0].UserGroupID);
      Session.set("FilePath", response[0].FilePath);
      Session.set("Email", response[0].Email);
      Session.set("EmailPassword", response[0].EmailPassword);
      Session.set("AccountGroup", response[0].AccountGroup);
      Session.set("AccountGroupID", response[0].AccountGroupID);
      Session.set("StoreID", response[0].StoreID);
      isFirst = true;
    } else if (isFirst === false) {
      setErrortext("Invalid Username or Password");
    }
  }, [response]);

  return (
    <Formik
      initialValues={{ userName: "", passWord: "" }}
      validationSchema={Yup.object({
        userName: Yup.string().required("Required"),
        passWord: Yup.string().required("Required"),
      })}
      onSubmit={(values, { setSubmitting }) => {
        setSubmitting(false);
        isFirst = false;
        var bodyFormData = new FormData();
        bodyFormData.append("UserName", values.userName);
        bodyFormData.append("Password", values.passWord);
        fetchData("User/Login", bodyFormData);
      }}
    >
      <div className="form-container">
        <Form id="loginform">
          <img src={LogoColor} alt="PM Logo" className="logo" />
          <section className="container" />
          <span className="icon">
            <i className="fas fa-user"></i>
          </span>
          <Field
            component="input"
            name="userName"
            label="Username"
            placeholder="Username"
            autoComplete="off"
          />
          <div className="container">
            <span className="icon">
              <i className="fas fa-lock"></i>
            </span>
            <Field
              name="passWord"
              label="Password"
              type="password"
              placeholder="Password"
            />
          </div>
          {errortext != "" ? (
            <label className="errorTextStyle">{errortext}</label>
          ) : null}
          <input type="submit" value="SIGN IN" />
        </Form>
      </div>
    </Formik>
  );
};

export default LoginGlass;
